import { render } from "./SalesTrends.vue?vue&type=template&id=303a53b9&scoped=true"
import script from "./SalesTrends.vue?vue&type=script&lang=js"
export * from "./SalesTrends.vue?vue&type=script&lang=js"

import "./SalesTrends.vue?vue&type=style&index=0&id=303a53b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303a53b9"]])

export default __exports__